<template>
  <div class="view-picture">
    <com-img-slider 
      v-if="imgs_list.length > 0"
      :img-list="imgs_list"
    ></com-img-slider>
    <slot name="user"></slot>
    <slot name="title"></slot>
    <slot name="content"></slot>
    <com-game-list
      v-if="game_card_list.length > 0"
     :game-card-list="game_card_list"
     ></com-game-list>
     <slot name="tag"></slot>
  </div>
</template>

<script>
import ComImgSlider from '../components/com-img-slider.vue';
import ComGameList from '../components/com-game-list.vue';
import { searchGamesList } from '_api/bbs/bbs'
import { formatWebpParams } from '_lib/utils'
export default {
  components: {
    ComImgSlider,
    ComGameList,
  },
  props: {
    linkInfo: {
      type: Object,
      default: () => ({})
    }
  },
  created () {
    this.handleData()
  },
  data () {
    return {
      imgs_list: [],
      game_card_list: []
    }
  },
  methods: {
    async handleData () {
      console.log(this.linkInfo);
      this.game_card_list =  await this.loadGameCard(
        this.linkInfo.content.map(item => {
          if (item.type == 'game_card') {
            return item.appid
          }
        }).filter(item => !!item)
      ) || []
      this.imgs_list = (await Promise.all(
        this.linkInfo.content.map(async (item, index) => {
          if (item.type == 'img') {
            return await this.handleTopImgae(item.url)
          }
        })
      )).filter(Boolean)
      console.log(this.game_card_list);
      console.log(this.imgs_list);
    },
    // 概念版加载游戏卡片
    async loadGameCard (game_list) {
      if (!game_list || game_list.length == 0) {
        return
      }
      const {data: {result, status}} = await searchGamesList({
        appids: game_list.join(',')
      })
      if (status != 'ok') return

      return (result.base_infos || [])
              .map(item => {
                item.image = formatWebpParams(item.image)
                return item
              })
    },
    /** 
     * 1.666 = 4 : 2.4
     * 1.1627 = 5 : 4.3
     * 0,75 = 3 : 4
     * 1 = 1 : 1
     */
     async handleTopImgae (url) {
      const img = new Image()
      let index = this.handle_concept_img_index || 0
      this.handle_concept_img_index = index + 1
      img.src = url
      return new Promise((resolve, reject) => {
        img.onload = () => {
          resolve({
            width: img.width,
            height: img.height,
            ratio: img.width / img.height,
            url
          })
        }
        img.onerror = () => {
          resolve(null)
        }
      })
    },
  }
}
</script>

<style lang="less">

</style>